const constants = require("./constants.json");

export const isStage = process.env.NEXT_PUBLIC_GOAL === "stage";
export const isProductionBuild = process.env.NODE_ENV === "production";

export const isDev = !isProductionBuild || isStage;
const current = isDev ? constants.development : constants.production;
export default current;
